export enum ReasonForLocationCaptureFailure {
  'Account Location Unknown' = 548910000,
  'Location Service Disabled' = 548910001,
  'Low Network/Offline' = 548910002,
  'Unable to Identify Reason' = 548910003,
  'Not supported for WFE meetings' = 548910004
}
